import type { CreateAttributeRequestApi, UpdateAttributeRequestApi } from '../types/attributes-api.types';
import type {
  CustomFieldDefinitionsPagingResult,
  GetCustomFieldDefinitionsParams,
  InsertCustomFieldDefinitionResult,
  UpdateCustomFieldDefinitionResult,
} from '../types/custom-field-definitions.types';
import {
  createAttributeFromRest,
  deleteAttributeFromRest,
  getAttributesFromRest,
  updateAttributeFromRest,
} from './attributes-rest.service';

export const getCustomFieldDefinitions = async (
  params: GetCustomFieldDefinitionsParams = {}
): Promise<CustomFieldDefinitionsPagingResult> =>
  getAttributesFromRest({
    pageNo: params.paging?.pageNo,
    pageSize: params.paging?.pageSize,
  });

export const insertCustomFieldDefinition = async (
  input: CreateAttributeRequestApi
): Promise<InsertCustomFieldDefinitionResult> => createAttributeFromRest(input);

export const updateCustomFieldDefinition = async (params: {
  key: string;
  input: UpdateAttributeRequestApi;
}): Promise<UpdateCustomFieldDefinitionResult> => updateAttributeFromRest(params);

export const deleteCustomFieldDefinition = async (
  key: string
): Promise<UpdateCustomFieldDefinitionResult> => deleteAttributeFromRest(key);
